import { makeStyles } from "@material-ui/core/styles";

export const wizardStyles = makeStyles((theme) => ({
  paper: {
    padding: 0,
    minHeight: "100vh",
  },
  picContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "2%",
  },
  container: {
    paddingTop: (props) => theme.spacing(props.step === "CREATE_USER" ? 1 : 4),
    paddingBottom: (props) =>
      theme.spacing(props.step === "CREATE_USER" ? 2 : 8),
  },
  root: {
    background: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  dot: {
    backgroundColor: "#C4C4C4",
    height: "13px",
    width: "13px",
  },
  dotActive: {
    backgroundColor: "#1F2B5A",
    height: "13px",
    width: "13px",
  },
  title: {
    textAlign: "center",
    color: "black",
    fontFamily: (props) => (props.step === "CREATE_USER" ? "Inter" : "Lato"),
    fontStyle: "normal",
    fontWeight: (props) => (props.step === "CREATE_USER" ? "500" : "400"),
    fontSize: (props) =>
      props.step === "CREATE_USER"
        ? theme.typography.pxToRem(24)
        : theme.typography.pxToRem(20),
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
  subtitle: {
    textAlign: "center",
    color: "black",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: theme.typography.pxToRem(24),
    paddingBottom: theme.spacing(4),
    lineHeight: "16px",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  innerContainer: {
    [theme.breakpoints.up("md")]: {
      width: (props) => (props.step === "CREATE_USER" ? "600px" : "100%"),
    },
    [theme.breakpoints.down("md")]: {
      width: (props) => (props.step === "CREATE_USER" ? "60%" : "100%"),
    },
  },
}));
